<template>
    <div>
        <CRow class="w-100">
            <CCol md="12" lg="12" sm="12" xs="12">
                <ReportsVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />
                <ReportCompanyVue class="pt-1" v-if="page == 'companies_reports'" @mtdBack="mtdBack" />
            </CCol>
        </CRow>
    </div>
</template>

<script>

import ReportsVue from '../../components/reportsHowert/Home.vue';
import ReportCompanyVue from '../../components/reportsHowert/ReportCompaniesDocument.vue';


export default {
    components: {
        ReportsVue,
        ReportCompanyVue,
    },
    data() {
        return {
            page: 'home',
        }
    },
    methods: {
        changePage(page) {
            this.page = page;
            this.$emit("mtdViewFooter", false, 'home');
        },
        returnHome() {
            this.page = 'home';
            this.$emit("mtdViewFooter", true, 'home');
        },
        hasRoles(roles) {
            return roles.some(role => this.userRoles.includes(role));
        },
        mtdBack: function () {
            this.page = 'home';
            // this.$emit('setView', 'home')
        },
        setView: function () {
            this.$emit('setView', 'home')
        }
    }
};
</script>